import { HSA_ONBOARD_STEPS } from '../constants';
import { atom, useAtom, useSetAtom } from 'jotai';

// Types
import { AccountConfigData, HSAData, NewCustomerData } from 'types';

export const currentStepAtom = atom(0);

const incOnboardingStepAtom = atom(null, (get, set) => {
  const currentStep = get(currentStepAtom);
  set(currentStepAtom, Math.min(currentStep + 1, HSA_ONBOARD_STEPS.length));
});

const decOnboardingStepAtom = atom(null, (get, set) => {
  const currentStep = get(currentStepAtom);
  set(currentStepAtom, Math.max(currentStep - 1, 0));
});

export const useOnboardingStepsAtom = () => {
  const decrementStep = useSetAtom(decOnboardingStepAtom);
  const incrementStep = useSetAtom(incOnboardingStepAtom);
  const [currentStep, setCurrentStep] = useAtom(currentStepAtom);

  return {
    currentStep,
    incrementStep,
    decrementStep,
    setCurrentStep,
  };
};

const onboardNewCustomerAtom = atom<NewCustomerData | null>(null);
export const useOnboardNewCustomerAtom = () => useAtom(onboardNewCustomerAtom);

const onboardAcctConfigAtom = atom<AccountConfigData | null>(null);
export const useOnboardAcctConfigAtom = () => useAtom(onboardAcctConfigAtom);

const onboardHSAConfigAtom = atom<HSAData | null>(null);
export const useOnboardHSAConfigAtom = () => useAtom(onboardHSAConfigAtom);
